import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import PrivacyPolicy from "../legal/PrivacyPolicy";

/**
 * Public, pre-rendered Privacy Policy page (ui#97). Renders the SAME {@link PrivacyPolicy} content
 * the "Resources" menu's dialog shows — one source, two surfaces — as in-flow SSG markup so the
 * legal copy is crawlable (E-E-A-T) instead of hidden behind a portal.
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.privacy.title}
				description={seo.privacy.description}
				path="/privacy"
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.privacy}</h1>
					<PrivacyPolicy/>
				</Prose>
			</ContentSurface>
		</>
	);
}
